import { gql } from '@apollo/client';

export const GET_PRACTITIONER_BY_ID = gql`
  query($id: ID!) {
    user {
      dashboard {
        practitionerById(id: $id) {
          id
          firstName
          lastName
          description
          email
          photoUrl
          gender
          phone
          notificationTypes
          birthDate
          preferredLanguages
          address {
            country
            city
            address
            zipcode
          }
          professionalNumber
          specialities
          subOrganizations {
            id
            name
            location {
              id
              name
              address {
                country
                city
                address
                zipcode
              }
              preferredTimeZone
            }
          }
          careTeams {
            id
            name
          }
          roles
          sendbirdId
          workingHours {
            dayOfWeek
            morningOpeningTime
            morningClosingTime
            afternoonOpeningTime
            afternoonClosingTime
          }
          appointmentDuration
        }
      }
    }
  }
`;
